module.exports = __webpack_public_path__ + "img/no_qrcode_page_bottom.b4dc2c8e.png";